(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer-market-shipping-bar"] && !Shopify.designMode) return;
  try {
    (function () {
    var STORAGE_PREFIX = 'cart-drawer-market-shipping:';

    function prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function parseIntAttr(value) {
      var parsed = parseInt(value, 10);
      return isNaN(parsed) ? 0 : parsed;
    }

    function calcProgressPercent(totalCents, thresholdCents) {
      if (thresholdCents <= 0) {
        return 0;
      }

      return Math.min(100, Math.round((totalCents / thresholdCents) * 100));
    }

    function formatRemainingAmount(remainingCents, currencySymbol, currencyIso) {
      var options = {
        style: 'currency',
        currency: Shopify.currency.active
      };

      if (remainingCents % 100 === 0) {
        options.minimumFractionDigits = 0;
        options.maximumFractionDigits = 0;
      }

      var formatted = new Intl.NumberFormat(Shopify.locale, options)
        .format(remainingCents / 100);

      if (currencyIso) {
        formatted = formatted.split(currencyIso).join('').replace(/\s+/g, ' ').trim();
      }

      if (currencySymbol && formatted.indexOf(currencySymbol) !== -1) {
        var numericPart = formatted.split(currencySymbol).join('').trim();
        formatted = currencySymbol + numericPart;
      }

      return formatted.replace(/\$/g, '$$$$');
    }

    function readStoredProgress(marketHandle) {
      try {
        var raw = sessionStorage.getItem(STORAGE_PREFIX + marketHandle);
        return raw ? JSON.parse(raw) : null;
      } catch (error) {
        return null;
      }
    }

    function writeStoredProgress(marketHandle, percent) {
      try {
        sessionStorage.setItem(
          STORAGE_PREFIX + marketHandle,
          JSON.stringify({ percent: percent, updatedAt: Date.now() })
        );
      } catch (error) {
        return;
      }
    }

    class CartDrawerMarketShippingBar extends HTMLElement {
      connectedCallback() {
        this._fill = this.querySelector('.cart-drawer__market-shipping-fill');
        this._message = this.querySelector('.cart-drawer__market-shipping-message');
        this._track = this.querySelector('.cart-drawer__market-shipping-track');
        this._reducedMotion = prefersReducedMotion();
        this._onCartChange = this._handleCartChange.bind(this);

        var marketHandle = this.dataset.marketHandle || 'default';
        var thresholdCents = parseIntAttr(this.dataset.thresholdCents);
        var totalCents = parseIntAttr(this.dataset.totalCents);
        var targetPercent = calcProgressPercent(totalCents, thresholdCents);
        var stored = readStoredProgress(marketHandle);
        var fromPercent =
          stored && typeof stored.percent === 'number'
            ? stored.percent
            : parseIntAttr(this.dataset.progressPercent);

        this._applyProgress(fromPercent, false);
        this._sync(totalCents, thresholdCents, targetPercent, !this._reducedMotion && fromPercent !== targetPercent);

        document.addEventListener('cart:change', this._onCartChange);
      }

      disconnectedCallback() {
        document.removeEventListener('cart:change', this._onCartChange);

        var marketHandle = this.dataset.marketHandle;
        if (!marketHandle || !this._fill) {
          return;
        }

        var percent = parseInt(this._fill.style.width, 10);
        if (!isNaN(percent)) {
          writeStoredProgress(marketHandle, percent);
        }
      }

      _getThresholdCents() {
        return parseIntAttr(this.dataset.thresholdCents);
      }

      _applyProgress(percent, animate) {
        if (!this._fill) {
          return;
        }

        if (!animate || this._reducedMotion) {
          this._fill.style.transition = 'none';
        } else {
          this._fill.style.transition = '';
        }

        this._fill.style.width = percent + '%';

        if (!animate || this._reducedMotion) {
          var fill = this._fill;
          requestAnimationFrame(function () {
            fill.style.transition = '';
          });
        }
      }

      _updateMessage(totalCents, thresholdCents) {
        if (!this._message) {
          return;
        }

        if (totalCents >= thresholdCents) {
          this._message.textContent = this.dataset.reachedMessage || '';
          return;
        }

        var remainingCents = thresholdCents - totalCents;
        var formattedAmount = formatRemainingAmount(
          remainingCents,
          this.dataset.currencySymbol || '',
          this.dataset.currencyIso || ''
        );
        var template = this.dataset.unreachedMessage || '';
        this._message.innerHTML = template
          .replace(/\[remaining_amount\]/g, formattedAmount)
          .replace(/\{\{\s*remaining_amount\s*\}\}/g, formattedAmount);
      }

      _updateAria(percent) {
        if (this._track) {
          this._track.setAttribute('aria-valuenow', String(percent));
        }
      }

      _sync(totalCents, thresholdCents, targetPercent, animate) {
        var self = this;

        if (animate) {
          requestAnimationFrame(function () {
            self._applyProgress(targetPercent, true);
          });
        } else {
          this._applyProgress(targetPercent, false);
        }

        this._updateMessage(totalCents, thresholdCents);
        this._updateAria(targetPercent);
        this.dataset.totalCents = String(totalCents);
        this.dataset.progressPercent = String(targetPercent);

        if (this.dataset.marketHandle) {
          writeStoredProgress(this.dataset.marketHandle, targetPercent);
        }
      }

      _handleCartChange(event) {
        var cart = event.detail && event.detail.cart;
        if (!cart) {
          return;
        }

        var totalCents = parseIntAttr(String(cart.total_price));
        var thresholdCents = this._getThresholdCents();
        var targetPercent = calcProgressPercent(totalCents, thresholdCents);
        var currentPercent = parseIntAttr(this.dataset.progressPercent);

        if (this._message && targetPercent !== currentPercent) {
          this._message.classList.add('is-updating');
        }

        this._sync(totalCents, thresholdCents, targetPercent, !this._reducedMotion);

        var message = this._message;
        if (message) {
          window.setTimeout(function () {
            message.classList.remove('is-updating');
          }, 200);
        }
      }
    }

    if (!window.customElements.get('cart-drawer-market-shipping-bar')) {
      window.customElements.define('cart-drawer-market-shipping-bar', CartDrawerMarketShippingBar);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-drawer-reassurance-slider"] && !Shopify.designMode) return;
  try {
    (function () {
    function prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    class CartDrawerReassuranceCarousel extends HTMLElement {
      connectedCallback() {
        this._slides = Array.from(this.querySelectorAll('.cart-drawer__reassurance-slide'));
        this._currentIndex = Math.max(
          0,
          this._slides.findIndex(function (slide) {
            return slide.classList.contains('is-selected');
          })
        );

        if (this._slides.length === 0) {
          return;
        }

        this._onBlockSelect = this._handleBlockSelect.bind(this);
        this._onBlockDeselect = this._handleBlockDeselect.bind(this);
        this._onDrawerBeforeShow = this._preloadImages.bind(this);
        this._onDrawerRefreshed = this._handleDrawerRefreshed.bind(this);
        this._cartDrawer = this.closest('cart-drawer');

        if (this._cartDrawer) {
          this._cartDrawer.addEventListener('dialog:before-show', this._onDrawerBeforeShow);
          this._cartDrawer.addEventListener('cart-drawer:refreshed', this._onDrawerRefreshed);
        }

        if (Shopify.designMode) {
          this.addEventListener('shopify:block:select', this._onBlockSelect);
          this.addEventListener('shopify:block:deselect', this._onBlockDeselect);
        }

        this._startAutoplay();
      }

      disconnectedCallback() {
        this._stopAutoplay();

        if (this._cartDrawer) {
          this._cartDrawer.removeEventListener('dialog:before-show', this._onDrawerBeforeShow);
          this._cartDrawer.removeEventListener('cart-drawer:refreshed', this._onDrawerRefreshed);
        }

        if (Shopify.designMode) {
          this.removeEventListener('shopify:block:select', this._onBlockSelect);
          this.removeEventListener('shopify:block:deselect', this._onBlockDeselect);
        }
      }

      _preloadImages() {
        this.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
          img.removeAttribute('loading');
        });
      }

      _handleDrawerRefreshed() {
        if (this._cartDrawer && this._cartDrawer.open) {
          this._preloadImages();
        }
      }

      _getIntervalMs() {
        var seconds = parseInt(this.getAttribute('autoplay'), 10);
        return (isNaN(seconds) ? 3 : seconds) * 1000;
      }

      _startAutoplay() {
        this._stopAutoplay();

        if (this._slides.length <= 1 || !this.hasAttribute('autoplay') || prefersReducedMotion()) {
          return;
        }

        var self = this;
        this._timer = window.setInterval(function () {
          self._select((self._currentIndex + 1) % self._slides.length);
        }, this._getIntervalMs());
      }

      _stopAutoplay() {
        if (this._timer) {
          window.clearInterval(this._timer);
          this._timer = null;
        }
      }

      _select(index) {
        if (!this._slides[index] || index === this._currentIndex) {
          return;
        }

        this._slides[this._currentIndex].classList.remove('is-selected');
        this._currentIndex = index;
        this._slides[this._currentIndex].classList.add('is-selected');
      }

      _handleBlockSelect(event) {
        var slide = event.target.closest('.cart-drawer__reassurance-slide');

        if (!slide) {
          return;
        }

        this._stopAutoplay();
        this._select(this._slides.indexOf(slide));
      }

      _handleBlockDeselect() {
        this._startAutoplay();
      }
    }

    if (!window.customElements.get('cart-drawer-reassurance-carousel')) {
      window.customElements.define('cart-drawer-reassurance-carousel', CartDrawerReassuranceCarousel);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
